import Popup from "@/gts-popup.js";
import store from "@/store/index.js";
import { flightService } from "@/service/index.js";
import { hotelService } from "@/service/index.js";
import { transferService } from "@/service/index.js";
import { nextTickControl } from "./nexTick";
import { setCookie } from "@/utils.js";
function openPopupElement() {
   var width = 500;
   var height = 500;
   var screenWidth = window.screen.width;
   var screenHeight = window.screen.height;
   var left = (screenWidth - width) / 2;
   var top = (screenHeight - height) / 2;
   return window.open("/loading", "paymentPostContentForm", `location=no, left=${left}, top=${top}, width=${width},height=${height}`);
}

function funcTicketReservedFlight(self, req) {
   let request = req;
   let msg = self.$i18n.t(`${self.$options.name}_progressGif_TicketReservedFlight`);
   let windowPopupElement;

   store.commit("app/showProgressGifMsg", msg);

   if (req.paymentType != 1 && !self.callback3D) {
      windowPopupElement = openPopupElement();
   }
   // console.log(`request:${JSON.stringify(request)}`);
   flightService.flightTicketReserved(request).then((response) => {
      // console.log(`response:${JSON.stringify(response)}`);
      store.commit("app/hideProgressGif");
      response.result.service = `TICKETRESERVED_FLIGHT`;
      if (!response.result.success) {
         Popup.result(response.result).then(() => {
            if (response.result.subCode == "PRICE_DIFFERENCE") window.location.reload();
         });
         self.paymentUuid = null;
         self.callback3D = false;
         if (windowPopupElement) {
            windowPopupElement.close();
         }
      } else {
         if (response.result.subCode == "PAYMENT_POST") {
            self.paymentPostContent = response.paymentPostContent;
            self.paymentUuid = response.paymentUuid;
            nextTickControl(self, windowPopupElement);
         } else {
            if (windowPopupElement) {
               windowPopupElement.close();
            }
            const popupCb = () => {
               window.location.reload();
            };
            Popup.result(response.result, popupCb).then(() => {
               window.location.reload();
            });
         }
      }
   });
}
function funcTicketReservedHotel(self, req) {
   let request = req;
   let msg = self.$i18n.t(`${self.$options.name}_progressGif_TicketReservedHotel`);
   let windowPopupElement;

   self.$store.commit("app/showProgressGifMsg", msg);

   if (req.payment.paymentType != 1 && !self.callback3D) {
      windowPopupElement = openPopupElement();
   }
   hotelService.hotelTicketReserved(request).then((response) => {
      setCookie("rooms", JSON.stringify(request.rooms), 0, 1);
      store.commit("app/hideProgressGif");
      response.result.service = `TICKETRESERVED_HOTEL`;
      if (!response.result.success) {
         Popup.result(response.result);
         self.paymentUuid = null;
         self.callback3D = false;
         return;
      } else {
         if (response.result.subCode == "PAYMENT_POST") {
            self.paymentPostContent = response.paymentPostContent;
            self.paymentUuid = response.paymentUuid;
            nextTickControl(self, windowPopupElement);
         } else {
            if (windowPopupElement) {
               windowPopupElement.close();
            }
            Popup.result(response.result).then(() => {
               window.location.reload();
            });
         }
      }
   });
}
function funcTicketReservedTransfer(self, req) {
   let request = req;
   let msg = self.$i18n.t(`${self.$options.name}_progressGif_TicketReservedTransfer`);
   let windowPopupElement;
   store.commit("app/showProgressGifMsg", msg);

   if (req.payment.paymentType != 1 && !self.callback3D) {
      windowPopupElement = openPopupElement();
   }
   //console.log(`request:${JSON.stringify(request)}`);
   transferService.transferTicketReserved(request).then((response) => {
      //console.log(`response:${JSON.stringify(response)}`);
      store.commit("app/hideProgressGif");
      response.result.service = `TICKETRESERVED_TRANSFER`;
      setCookie("travelerData", JSON.stringify(request.travellers), 0, 1);
      if (!response.result.success) {
         Popup.result(response.result);
         self.paymentUuid = null;
         self.callback3D = false;
         return;
      } else {
         if (response.result.subCode == "PAYMENT_POST") {
            self.paymentPostContent = response.paymentPostContent;
            self.paymentUuid = response.paymentUuid;
            nextTickControl(self, windowPopupElement);
         } else {
            if (windowPopupElement) {
               windowPopupElement.close();
            }
            Popup.result(response.result).then(() => {
               window.location.reload();
            });
         }
      }
   });
}
export { funcTicketReservedFlight, funcTicketReservedHotel, funcTicketReservedTransfer };
